import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Users } from "lucide-react";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const params = new URLSearchParams(window.location.hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    (async () => {
      if (!sessionId) { navigate("/login"); return; }
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        localStorage.setItem("saathly_token", data.token);
        setUser(data.user);
        window.history.replaceState(null, "", window.location.pathname);
        toast.success(`Welcome, ${data.user.name.split(" ")[0]}!`);
        navigate(data.user.role === "admin" ? "/admin" : (data.user.needs_onboarding ? "/onboarding" : "/dashboard"));
      } catch {
        toast.error("Google sign-in failed. Please try again.");
        navigate("/login");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-sand">
      <Users className="w-12 h-12 text-terracotta animate-pulse" />
      <p className="font-display text-xl text-charcoal mt-4">Signing you in…</p>
    </div>
  );
}
